import { render } from "./404.vue?vue&type=template&id=af4c2d6e&ts=true"
import script from "./404.vue?vue&type=script&lang=ts"
export * from "./404.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Code\\hjp\\yijian-proxy-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__